import React from 'react';
import { Tabs, TabContent } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'Utils';
import { RoleService } from 'Services';
import styles from 'Routes/Overrides/Overrides.css';
import appStyles from 'Routes/Routes.css';
import useGetTenantGroupColumns from 'Hooks/useGetTenantGroupColumns';
import TabState from 'Components/TabState';
import { shouldShowTenantGroups } from 'Selectors';
import TenantsTable from './components/TenantsTable';
import TenantGroupsTable from './components/TenantGroupsTable';
import Header from './components/Header';

const ManageTenants = () => {
    const { tab } = useSearchParams();
    const { t } = useTranslation();
    const [tabName, setTabName] = React.useState<string>('tenant-group-tab');
    const [toggleButton, setToggleButton] = React.useState<boolean>(true);
    const [deleteTenantGroup, setDeleteTenantGroup] = React.useState<TenantGroup | undefined>(undefined);
    const [toggleModal, setToggleModal] = React.useState<boolean>(false);
    const handleDelete = (tenantGroup: TenantGroup) => {
        setDeleteTenantGroup(tenantGroup);
        setToggleModal(true);
    };
    const columns = useGetTenantGroupColumns({ handleDelete });

    React.useEffect(() => {
        switch (tabName) {
            case 'tenants-tab':
                setToggleButton(false);
                break;

            default:
                setToggleButton(true);
                break;
        }
    }, [tabName]);

    return (
        <div className={appStyles.landingPage}>
            <Header toggleAddTentantGroupButton={toggleButton} />
            {shouldShowTenantGroups() ? (
                <Tabs
                    className={styles.overridesTabs}
                    startIndex={tab === 'tenants' && RoleService.hasTenantGroupReadAccess ? 1 : 0}
                    type='small'
                >
                    {RoleService.hasTenantGroupReadAccess && (
                        <TabContent headerTestId='tenant-group-tab' hidden label={t('Tenant Groups')}>
                            <TabState setTabName={setTabName} tabId='tenant-group-tab'>
                                <TenantGroupsTable
                                    mode='manageTenantGroups'
                                    columns={columns}
                                    deleteTenantGroup={deleteTenantGroup}
                                    toggleModal={toggleModal}
                                    setToggleModal={setToggleModal}
                                />
                            </TabState>
                        </TabContent>
                    )}
                    <TabContent headerTestId='tenants-tab' hidden label={t('Tenants')}>
                        <TabState setTabName={setTabName} tabId='tenants-tab'>
                            <TenantsTable />
                        </TabState>
                    </TabContent>
                </Tabs>
            ) : (
                <TenantsTable />
            )}
        </div>
    );
};

export default ManageTenants;
